import { env } from '@cc-shopping/platform-env';
import { CARDFINDER_TRAVEL_BRANCH_PATH } from './constants';

export function getCardfinderTravelUrl() {
  return `${env.NEXT_PUBLIC_NW_URL.replace(/\/$/, '')}${CARDFINDER_TRAVEL_BRANCH_PATH}`;
}
